import { Scenario, ScenarioType, Steps } from '../state/interfaces'

import {
  emailAddressAlert,
  confirmAlert,
  thanksAlertMobile,
  thanksAlertInternet,
  startMobileAlert,
  startInternetAlert,
  provincesStepMobileAlert,
  postalCodeAlert,
  internetSpeedAlert,
  emailAddressFiberOpticAlert,
  addressLocationFiberOpticAlert,
  confirmFiberOpticAlert,
  confirmFiberOpticSignup,
  emailAddressObserverAlertMobile,
  emailAddressObserverAlertInternet,
  currentProviderInternetObserverAlert,
  currentProviderMobileObserverAlertA,
  provincesStepMobileObserverAlert,
  currentInternetSpeedAlertObserver,
  sliderDataInternetAlertObserver,
  currentMonthlyPaymentObserverAlert,
  // callingOptionsAlertObserver,
  howMuchDataAlertObserver,
  sliderDataMobileAlertObserver,
  postalCodeAlertObserver,
  internetSpeedAlertB,
  sliderDataAlert,
  confirmFiberOpticAlertB,
  thanksFiberOpticAlert,
} from './alert-steps'
import {
  buyOrBringPhoneMobileSearchEmail,
  chooseBrandsAndroidMobileSearchEmail,
  chooseBrandsMobileSearchEmail,
  chooseBrandsProprietaryMobileSearchEmail,
  choosePhoneCameraMobileSearchEmail,
  choosePhoneFromListMobileSearchEmail,
  choosePhoneMemoryMobileSearchEmail,
  choosePhoneOsMobileSearchEmail,
  choosePhoneSizeMobileSearchEmail,
  howManyCallingMinutesMobileSearchEmail,
  howMuchDataMobileSearchEmail,
} from './mobile-search-email-steps'
import { coverage, howManyCallingMinutesC, howManyCallingMinutesE, howMuchDataC, sliderDataG } from './mobile-steps'

export const mobileAlertScenarioA: Scenario = {
  id: 'mobile-alert-a',
  initialStep: Steps.START_MOBILE_ALERT,
  type: ScenarioType.MOBILE_ALERT,
  version: '1',
  milestones: [
    startMobileAlert.id,
    provincesStepMobileAlert.id,
    howManyCallingMinutesMobileSearchEmail.id,
    howMuchDataMobileSearchEmail.id,
    buyOrBringPhoneMobileSearchEmail.id,
    choosePhoneOsMobileSearchEmail.id,
    chooseBrandsMobileSearchEmail.id,
    choosePhoneSizeMobileSearchEmail.id,
    choosePhoneCameraMobileSearchEmail.id,
    choosePhoneMemoryMobileSearchEmail.id,
    choosePhoneFromListMobileSearchEmail.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertMobile.id,
  ],
  steps: [
    startMobileAlert,
    provincesStepMobileAlert,
    howManyCallingMinutesMobileSearchEmail,
    howMuchDataMobileSearchEmail,
    buyOrBringPhoneMobileSearchEmail,
    choosePhoneOsMobileSearchEmail,
    chooseBrandsMobileSearchEmail,
    chooseBrandsAndroidMobileSearchEmail,
    chooseBrandsProprietaryMobileSearchEmail,
    choosePhoneSizeMobileSearchEmail,
    choosePhoneCameraMobileSearchEmail,
    choosePhoneMemoryMobileSearchEmail,
    choosePhoneFromListMobileSearchEmail,
    emailAddressAlert,
    confirmAlert,
    thanksAlertMobile,
  ],
  weight: 0,
}

export const internetAlertScenarioA: Scenario = {
  id: 'internet-alert-a',
  initialStep: Steps.START_INTERNET_ALERT,
  type: ScenarioType.INTERNET_ALERT,
  version: '1',
  milestones: [
    startInternetAlert.id,
    internetSpeedAlert.id,
    postalCodeAlert.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertInternet.id,
  ],
  steps: [
    startInternetAlert,
    internetSpeedAlert,
    postalCodeAlert,
    emailAddressAlert,
    confirmAlert,
    thanksAlertInternet,
  ],
  weight: 0,
}

export const mobileAlertScenarioB: Scenario = {
  id: 'mobile-alert-b',
  initialStep: Steps.START_MOBILE_ALERT,
  type: ScenarioType.MOBILE_ALERT,
  version: '1',
  milestones: [
    startMobileAlert.id,
    provincesStepMobileAlert.id,
    howManyCallingMinutesC.id,
    howMuchDataC.id,
    sliderDataG.id,
    buyOrBringPhoneMobileSearchEmail.id,
    choosePhoneOsMobileSearchEmail.id,
    chooseBrandsMobileSearchEmail.id,
    choosePhoneSizeMobileSearchEmail.id,
    choosePhoneCameraMobileSearchEmail.id,
    choosePhoneMemoryMobileSearchEmail.id,
    choosePhoneFromListMobileSearchEmail.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertMobile.id,
  ],
  steps: [
    startMobileAlert,
    provincesStepMobileAlert,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhoneMobileSearchEmail,
    choosePhoneOsMobileSearchEmail,
    chooseBrandsMobileSearchEmail,
    chooseBrandsAndroidMobileSearchEmail,
    chooseBrandsProprietaryMobileSearchEmail,
    choosePhoneSizeMobileSearchEmail,
    choosePhoneCameraMobileSearchEmail,
    choosePhoneMemoryMobileSearchEmail,
    choosePhoneFromListMobileSearchEmail,
    emailAddressAlert,
    confirmAlert,
    thanksAlertMobile,
  ],
  weight: 1,
}

export const internetAlertScenarioB: Scenario = {
  id: 'internet-alert-b',
  initialStep: Steps.START_INTERNET_ALERT,
  type: ScenarioType.INTERNET_ALERT,
  version: '1',
  milestones: [
    startInternetAlert.id,
    internetSpeedAlertB.id,
    sliderDataAlert.id,
    postalCodeAlert.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertInternet.id,
  ],
  steps: [
    startInternetAlert,
    internetSpeedAlertB,
    sliderDataAlert,
    postalCodeAlert,
    emailAddressAlert,
    confirmAlert,
    thanksAlertInternet,
  ],
  weight: 1,
}

export const internetFiberOpticAlertScenarioA: Scenario = {
  id: 'internet-fiber-optic-alert-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.FIBER_OPTIC_ALERT,
  version: '1',
  milestones: [
    emailAddressFiberOpticAlert.id,
    addressLocationFiberOpticAlert.id,
    confirmFiberOpticAlert.id,
    confirmFiberOpticSignup.id,
  ],
  steps: [emailAddressFiberOpticAlert, addressLocationFiberOpticAlert, confirmFiberOpticAlert, confirmFiberOpticSignup],
  weight: 0,
}

export const internetFiberOpticAlertScenarioB: Scenario = {
  id: 'internet-fiber-optic-alert-b',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.FIBER_OPTIC_ALERT,
  version: '1',
  milestones: [
    emailAddressFiberOpticAlert.id,
    addressLocationFiberOpticAlert.id,
    confirmFiberOpticAlertB.id,
    thanksFiberOpticAlert.id,
  ],
  steps: [emailAddressFiberOpticAlert, addressLocationFiberOpticAlert, confirmFiberOpticAlertB, thanksFiberOpticAlert],
  weight: 1,
}

export const mobileAlertObserverScenarioA: Scenario = {
  id: 'mobile-alert-observer-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.MOBILE_ALERT_OBSERVER,
  version: '1',
  milestones: [
    emailAddressObserverAlertMobile.id,
    provincesStepMobileObserverAlert.id,
    currentProviderMobileObserverAlertA.id,
    howMuchDataAlertObserver.id,
    currentMonthlyPaymentObserverAlert.id,
    confirmAlert.id,
    thanksAlertMobile.id,
  ],
  steps: [
    emailAddressObserverAlertMobile,
    provincesStepMobileObserverAlert,
    currentProviderMobileObserverAlertA,
    coverage,
    howMuchDataAlertObserver,
    sliderDataMobileAlertObserver,
    currentMonthlyPaymentObserverAlert,
    confirmAlert,
    thanksAlertMobile,
  ],
}

export const internetAlertObserverScenarioA: Scenario = {
  id: 'internet-alert-observer-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.INTERNET_ALERT_OBSERVER,
  version: '1',
  milestones: [
    emailAddressObserverAlertInternet.id,
    currentProviderInternetObserverAlert.id,
    currentInternetSpeedAlertObserver.id,
    postalCodeAlertObserver.id,
    currentMonthlyPaymentObserverAlert.id,
    confirmAlert.id,
    thanksAlertInternet.id,
  ],
  steps: [
    emailAddressObserverAlertInternet,
    currentProviderInternetObserverAlert,
    currentInternetSpeedAlertObserver,
    sliderDataInternetAlertObserver,
    postalCodeAlertObserver,
    currentMonthlyPaymentObserverAlert,
    confirmAlert,
    thanksAlertInternet,
  ],
}
